<template>
    <v-app>
        <Layout>
            <PageHeader :title="title" :items="items" />

           

            <v-row>
                <v-card class="mb-1 pt-4">
                   <v-row>
                        <v-col cols="5" md="2" class="ml-5">
                            <v-text-field type="date" label="Data inicial:" v-model="editedItem.dataInicial"></v-text-field>
                        </v-col>
                        <v-col cols="5" md="2">
                            <v-text-field type="date" label="Data final:" v-model="editedItem.dataFinal"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>
                
                <v-card height="500">
                    <v-btn @click="relatorio" :disabled="loading"
                        >Relatório de vendas por período</v-btn
                    >
                    <v-btn @click="relatorioFinanceiro" :disabled="loading"
                        >Relatório de Financeiro</v-btn
                    >
                    <v-btn @click="produtosMaisVendidos" :disabled="loading"
                        >Relatório de Produtos mais vendidos</v-btn
                    >
                    <v-btn @click="servicosMaisVendidos" :disabled="loading"
                        >Relatório de Serviços mais vendidos</v-btn
                    >

                    <hr class="mt-5">
                    <h3>Relatório por vendedor</h3>
                    <h6>Dica: Escolha um vendedor abaixo ou deixe em branco para listar todos.</h6>
                    <v-row >
                        <v-col cols="6">
                            <v-select
                                :items="vendedores"
                                item-text="nome"
                                item-value="id"
                                label="Vendedor"
                                filled
                                class="mr-1 mt-1 mt-lg-0"
                                :background-color="colorInput"
                                return-object
                                v-model="vendedor"
                            ></v-select>
                        </v-col>
                        <v-col cols="6">
                            <v-btn 
                                height="50px" 
                                block 
                                @click="relatorioPorVendedores" 
                                disable="loading"
                                class="custom-color-button"
                                >Gerar</v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-row>

            <v-row>
                <v-dialog
                    v-model="dialog"
                    max-width="1000px"
                    fullscreen
                    scrollable
                    class="dialog-above-menu"
                >
                    <!-- <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                    <v-icon>add_box</v-icon>
                </v-btn>
                </template> -->
                    <v-form ref="form" v-model="formValido" lazy-validation>
                        <!-- <v-card color="#EEEEEE"> -->
                        <v-card :color="colorDialog">
                            <v-card-title :style="{ color: corTitulo }">
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-divider></v-divider>

                            <v-card-text
                                class="custom-scroll"
                                :style="{ '--scrollbar-color': corTitulo }"
                            >
                                <!-- <v-container> -->
                                <v-row class="no-gutters">
                                    <!-- <v-col cols="2" sm="2" md="2">
                                    <v-text-field v-model="editedItem.id" label="ID" disabled></v-text-field>
                                </v-col> -->
                                    <h4>Dados Principais</h4>
                                </v-row>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close"
                                    >Cancelar</v-btn
                                >
                                <v-btn
                                    color="pink accent-3"
                                    text
                                    @click="save"
                                    :disabled="!formValido"
                                    >Salvar</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </v-row>
        </Layout>
    </v-app>
    <!-- class="ml-1 mb-sm-4 custom-color-button custom-border-bottom" -->
</template>




<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import { ApiRelatorio } from "./ApiRelatorio";
import { ApiFac } from "../fac/ApiFac";
//import { ApiCmp } from "./ApiCmp";

//import { ApiFac } from "../fac/ApiFac";
import mensagemMixin from "@/mixins/mensagensMixin.js";
//import {formatarParaGuarani} from '@/assets/util/myFunctions' //caracter estranho no pdf

import axios from "axios";
import jsPDF from "jspdf";
import moment from "moment";

export default {
    name: "Relatorio",
    components: {
        Layout,
        PageHeader,
    },
    props: [],
    mixins: [mensagemMixin],
    data() {
        return {
            title: "Relatórios",
            items: [
                {
                    text: "Dashboard",
                    href: "/home",
                },
                {
                    text: "Relatórios",
                    active: true,
                },
            ],
            vendedor: null,
            vendedores: [],
            produtos: [],
            servicos: [],
            empresa: {},
            itens: [],
            comandas: [],
            receitas: [],
            totalVendedores: [],
            totalVendasPorTipoPgto: [],
            api: new ApiRelatorio(),
            apiFac: new ApiFac(),
            //ApiFac: new ApiFac(),
            loading: false,
            search: "",
            file: null,
            recurso: "fornecedor",
            colorInput: "#fff",
            colorCheckbox: "#26A69A",
            corTitulo: "#795548",
            //colorInput: "#FFE57F",
            //colorInput: "#EDE7F6",
            //colorDialog: "#FFD740",
            colorDialog: "rgba(255, 215, 64, 0.95)", //cor unica amarelo:#f2c438 roxo:#82566a
            //colorDialog: "#ccc",
            headers: [
                { text: "ID", value: "id" },
                {
                    text: "Nome",
                    align: "start",
                    sortable: false,
                    value: "nome",
                },
                { text: "Ações", value: "acoes", sortable: false },
            ],
            dialog: false,
            editedIndex: -1,
            editedItem: {
                dataInicial: moment(new Date()).format("YYYY-MM-DD"),
                dataFinal: moment(new Date()).format("YYYY-MM-DD"),
            },
            defaultItem: {
                dataInicial: moment(new Date()).format("YYYY-MM-DD"),
                dataFinal: moment(new Date()).format("YYYY-MM-DD"),
            },
            textRules: [(v) => !!v || "Requerido"],
            formValido: true,
        };
    },
    created() {
        //this.listarPaises()
        this.iniciar();
        
    },
    mounted() {
        if (
            localStorage.getItem("empresa") !== "undefined" &&
            localStorage.getItem("empresa") !== null
        ) {
            this.empresa = JSON.parse(localStorage.getItem("empresa"));
            /* NOVO...Quando dava refresh na página ele perdia o estado ...fazer em todos os componentes */
            this.$store.dispatch("company/changeEmpresa", this.empresa);
        } else {
            this.mensagem("Selecione uma empresa!", "Atenção", "warning"); //mixin
            this.empresa = {};
            this.$router.push("/empresas");
        }

        this.listarVendedores()
    },
    methods: {
        async listarVendedores(){
            let resultado = await this.apiFac.getColaborador(-1, "","", this.empresa.id);
            console.log('=>VENDEDORES',resultado);
            if(resultado){
                this.vendedores = resultado
            }
        },
        async iniciar() {
            try {
                this.loading = true;
                //let resultado = await this.api.getFornecedores();
                //this.itens = resultado;
            } catch (error) {
                alert(error);
            } finally {
                this.loading = false;
            }
        },
        async openDialog() {
            //await new Promise(resolve => setTimeout(resolve, 100))
            this.dialog = true;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        editItem(item) {
            this.editedIndex = this.itens.indexOf(item);
            this.editedItem = Object.assign({}, item);
            //delete this.editedItem.celular
            //this.$set(this.editedItem, "celular", {number: null, country:{}, valid: null})
            //this.editedItem.celular.number = item.celular
            this.dialog = true;
        },
        async deleteItem(item) {
            this.$swal
                .fire({
                    title: "Tem certeza?",
                    html: `Apagar o ${this.recurso} <br><b>${item.nome}</b>`,
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Sim!",
                    cancelButtonText: "Não!",
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                })
                .then(async (result) => {
                    if (result.isConfirmed) {
                        let resposta = await this.api.delFornecedor(item.id);
                        this.iniciar();
                        if (resposta.status == 204) {
                            this.$toastr.s(`Eliminado ${item.nome}`);
                        } else if (resposta.status >= 400) {
                            if (resposta.data.detail) {
                                this.$toastr.e(`${resposta.data.detail}`);
                            } else if (resposta.data) {
                                this.$toastr.e(
                                    `${JSON.stringify(resposta.data)}`
                                );
                            } else {
                                this.$toastr.e(`${resposta.statusText}`);
                            }
                        }
                    } else {
                        this.$swal.fire(
                            "Cancelado!",
                            `O ${this.recurso} foi mantido.`,
                            "info"
                        );
                    }
                });
        },
        async save() {
            console.log(
                "======================save===================================="
            );
            console.log(this.editedItem);
            console.log(
                "============================================================="
            );

            if (this.editedItem.nome.length <= 3) {
                this.$swal({
                    title: "Erro!",
                    text: "Campo nome deve ter mais de três caracteres",
                    icon: "error",
                });
                return false;
            }

            /*  */
            /* ADICONANDO OS CAMPOS NORMAIS */
            const fornecedor = {};
            for (const key in this.editedItem) {
                console.log(`${key}->${this.editedItem[key]}`);
                if (
                    this.editedItem[key] !== null &&
                    this.editedItem[key] !== ""
                )
                    //fornecedor.append(key, fornecedor[key]);
                    fornecedor[key] = this.editedItem[key];
            }

            /* ADICIONANDO OS _id tem que ser igual ao nome que está no model no backend */
            const relacionamentos = [
                "nacionalidade",
                "pais",
                "estado",
                "cidade",
            ];
            relacionamentos.forEach((relacionamento) => {
                if (
                    this.editedItem[relacionamento] !== undefined &&
                    this.editedItem[relacionamento] !== null &&
                    this.editedItem[relacionamento].id !== null
                )
                    fornecedor[`${relacionamento}_id`] =
                        this.editedItem[relacionamento].id;
            });

            /* CAMPOS EXTRAS SE TIVER */
            fornecedor.celular = this.editedItem.celular.number;
            fornecedor.telefone = this.editedItem.telefone.number;

            /* ADICIONAR IMAGEM SE TIVER */
            if (this.file) fornecedor.imagem = this.file;

            console.log(
                "zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz"
            );
            console.log("Fornecedor ", fornecedor);
            console.log(
                "zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz"
            );
            /*  */

            const obj = new FormData();
            for (const key in fornecedor) {
                if (key == "imagem") {
                    if (fornecedor[key] !== null)
                        obj.append("imagem", fornecedor[key]);
                } else {
                    obj.append(key, fornecedor[key]);
                }
            }

            try {
                this.loading = true;
                let resposta = await this.api.saveFornecedor(obj);
                if (resposta.data.id) {
                    this.mensagem(`${this.recurso} salvo com sucesso!`);
                    this.iniciar();
                } else if (resposta.status >= 400) {
                    if (resposta.data.detail) {
                        this.mensagem(resposta.data.detail, "Erro1", "error");
                    } else if (resposta.data) {
                        this.mensagem(
                            JSON.stringify(resposta.data),
                            "Erro2",
                            "error"
                        );
                    } else {
                        this.mensagem("Erro desconhecido", "Erro3", "error");
                    }
                }
            } catch (error) {
                this.$swal({
                    title: "Erro!",
                    text: error.toString(),
                    icon: "error",
                });
            } finally {
                this.loading = false;
            }
        },

        /* USAR PARA LISTAR RELACIONAMENTOS */
        /* async listarPaises() {
      try {
        this.loading = true;
        const paises = await this.apiFac.getPais(-1);
        if (paises.status >= 400) {
          if (paises.status == 403) {
            //this.mensagem("Sem permissão para executar essa ação", "Atenção", "error");
            this.$toastr.w(`${paises.statusText}`);
            this.paises = [];
          } else if (paises.status == 404) {
            this.mensagem("Pais não cadastrado", "Atenção", "warning");
          } else {
            this.mensagem(paises.statusText, "Atenção", "warning");
          }
        } else {
          this.paises = paises;
        }
      } catch (error) {
        this.mensagemErro('Países: ', error);
      } finally {
        this.loading = false;
      }
    }, */

        /* FORMATA DATA E EXIBE CARACTERES NO CASO DE NÃO TER DATA */
        formatDate(date) {
            const formattedDate = this.moment(date).format("DD/MM/YYYY");
            return this.moment(date).isValid() ? formattedDate : "-----";
        },

        formataGuarani(arg) {
            console.log("formataGuarani", arg);
            const formatter = new Intl.NumberFormat("es-PY", {
                style: "currency",
                currency: "PYG",
                minimumFractionDigits: 0, // Defina como 0 para formatar como moeda inteira
                maximumFractionDigits: 0, // Defina como 0 para formatar como moeda inteira
            });

            return formatter.format(arg);
        },

        async relatorio() {
            /* zerar o vendedor para imprimir o nome deles no relatório vendas por período */
            this.vendedor = null
            let data_inicial = this.editedItem.dataInicial;
            let data_final = this.editedItem.dataFinal;
            let empresa = this.empresa.id;
            const servidor = this.api.SERVER_URL;
            const token = localStorage.getItem("access");


            const headers = {
                Authorization: `Bearer ${token}`,
            };

            try {
                this.loading = true;

                const response = await axios.get(
                    `${servidor}comanda/relatorio_faturado/`,
                    {
                        params: { empresa, data_inicial, data_final },
                        headers: headers,
                    }
                );

                if (response.status == 401) {
                    this.$router.push("login");
                    this.mensagem(
                        "Faça login novamente!",
                        "Atenção",
                        "warning",
                        2
                    );
                    return false;
                }

                console.log("RETORNO DO SERVIDOR: ", response);
                console.log("RETORNO DO SERVIDOR: ", response.data.comandas);
                console.log("RETORNO DO SERVIDOR: ", response.data.vendas);
                const comandas = response.data.comandas;
                const vendas = response.data.vendas;
                comandas.map((comanda) => {
                    console.log(
                        "comanda:",
                        comanda.id,
                        "total:",
                        comanda.total
                    );
                });
                vendas.map((venda) => {
                    console.log(venda);
                });
                if (response.status === 200) {
                    this.comandas = response.data.comandas;
                    this.totalVendedores = response.data.vendas;
                    if(response.data.comandas.length > 0) {
                        this.gerarPdfRelatorio();
                        this.mensagem("ok", "Aviso", "success", 1);
                    } else{
                        this.mensagem("Sem dados no período para gerar o relatório!!!", "Aviso", "warning", 3);
                    }
                }
            } catch (error) {
                this.loading = false;

                console.error("Erro ao gerar:", error.response);
                if (error.response.status == 401) {
                    this.$router.push("login");
                    this.mensagem(
                        "Faça login novamente!",
                        "Atenção",
                        "warning",
                        2
                    );
                    return false;
                } else {
                    this.mensagem(error.response.data.detail, 'Atenção', 'warning', 2);
                
                }
            }
            this.loading = false;
        },
        async relatorioPorVendedores() {
            let data_inicial = this.editedItem.dataInicial;
            let data_final = this.editedItem.dataFinal;
            let empresa = this.empresa.id;
            const servidor = this.api.SERVER_URL;
            const token = localStorage.getItem("access");

            const vendedor = this.vendedor?.id || null

            const headers = {
                Authorization: `Bearer ${token}`,
            };

            try {
                this.loading = true;

                const response = await axios.get(
                    `${servidor}comanda/relatorio_faturado/`,
                    {
                        params: { empresa, data_inicial, data_final, vendedor },
                        headers: headers,
                    }
                );

                if (response.status == 401) {
                    this.$router.push("login");
                    this.mensagem(
                        "Faça login novamente!",
                        "Atenção",
                        "warning",
                        2
                    );
                    return false;
                }

                console.log("RETORNO DO SERVIDOR: ", response);
                console.log("RETORNO DO SERVIDOR: ", response.data.comandas);
                console.log("RETORNO DO SERVIDOR: ", response.data.vendas);
                const comandas = response.data.comandas;
                const vendas = response.data.vendas;
                comandas.map((comanda) => {
                    console.log(
                        "comanda:",
                        comanda.id,
                        "total:",
                        comanda.total
                    );
                });
                vendas.map((venda) => {
                    console.log(venda);
                });
                if (response.status === 200) {
                    this.comandas = response.data.comandas;
                    this.totalVendedores = response.data.vendas;
                    if(response.data.comandas.length > 0) {
                        this.gerarPdfRelatorio();
                        this.mensagem("ok", "Aviso", "success", 1);
                    } else{
                        this.mensagem("Sem dados no período para gerar o relatório!!!", "Aviso", "warning", 3);
                    }
                }
            } catch (error) {
                this.loading = false;

                console.error("Erro ao gerar:", error.response);
                if (error.response.status == 401) {
                    this.$router.push("login");
                    this.mensagem(
                        "Faça login novamente!",
                        "Atenção",
                        "warning",
                        2
                    );
                    return false;
                } else {
                    this.mensagem(error.response.data.detail, 'Atenção', 'warning', 2);
                
                }
            }
            this.loading = false;
        },

        async relatorioFinanceiro() {
            let data_inicial = this.editedItem.dataInicial;
            let data_final = this.editedItem.dataFinal;
            let empresa = this.empresa.id;
            const servidor = this.api.SERVER_URL;
            const token = localStorage.getItem("access");
            const headers = {
                Authorization: `Bearer ${token}`,
            };

            try {
                this.loading = true;

                const response = await axios.get(
                    `${servidor}comanda/relatorio_financeiro/`,
                    {
                        params: { empresa, data_inicial, data_final },
                        headers: headers,
                    }
                );

                if (response.status == 401) {
                    this.$router.push("login");
                    this.mensagem(
                        "Faça login novamente!",
                        "Atenção",
                        "warning",
                        2
                    );
                    return false;
                } else if (response.status > 401){
                    if (response.detail){
                        this.mensagem(response.detail, "Aviso", "error", 3);
                    }
                }

                console.log("RETORNO DO SERVIDOR: ", response);
                console.log("RETORNO DO SERVIDOR: ", response.data.receitas);
                console.log("RETORNO DO SERVIDOR: ", response.data.vendas);
                
                if (response.status === 200) {
                    this.receitas = response.data.receitas;
                    this.totalVendedores = response.data.vendas;
                    this.totalVendasPorTipoPgto = response.data.vendas_por_tipo_pgto;
                    this.gerarPdfRelatorioFinanceiro();
                    this.mensagem("ok", "Aviso", "success", 1);
                }
            } catch (error) {
                this.loading = false;

                console.error("Erro ao gerar:", error.response);
                if (error.response.status == 401) {
                    this.$router.push("login");
                    this.mensagem(
                        "Faça login novamente!",
                        "Atenção",
                        "warning",
                        2
                    );
                    return false;
                } else {
                    this.mensagem(error.response.data.detail, 'Atenção', 'warning', 2);
                }
            }
            this.loading = false;
        },

        gerarCabecalhoVendas(doc, linha) {
          let txtColaborador = 'COLABORADOR'
          if(this.vendedor){
             txtColaborador = this.vendedor.genero == 'masculino' ? txtColaborador : this.vendedor.genero == 'feminino' ? 'COLABORADORA' : txtColaborador
          }
          doc.setFont("helvetica", 'bold');
          doc.setFontSize(10);
          doc.text(txtColaborador, 10, linha );
          doc.text('VALOR', 164, linha );
          doc.text('VALOR FATURADO', 187, linha );
          doc.setFont("helvetica", 'normal');
        },

        gerarCabecalho(doc, linha) {
          let tituloRelatorio = 'Relatório de vendas por período'
          tituloRelatorio = this.vendedor ? 'Relatório de vendas por colaborador' : tituloRelatorio
          doc.setFont("helvetica", 'bold');
          doc.setFontSize(24);
          doc.text(tituloRelatorio, 10, linha-10 );
          //linha += 5
          doc.setFontSize(10);
          doc.text('COMANDA', 10, linha );
          doc.text('DATA', 30, linha );
          doc.text('CLIENTE', 50, linha );
          doc.text('VALOR', 164, linha );
          doc.text('VALOR FATURADO', 187, linha );
          this.vendedor ? '' : doc.text('VENDEDOR', 230, linha ); 
          doc.setFont("helvetica", 'normal');
        },

        gerarCabecalhoVendasFinanceiro(doc, linha) {
          doc.setFont("helvetica", 'bold');
          doc.setFontSize(10);
          doc.text('COLABORADOR', 10, linha );
          doc.text('VALOR', 166, linha );
          doc.setFont("helvetica", 'normal');
        },

        gerarCabecalhoFinanceiro(doc, linha) {
          doc.setFont("helvetica", 'bold');
          doc.setFontSize(24);
          doc.text('Relatório de movimentos liquidados por período', 10, linha-10 );
          //linha += 5
          doc.setFontSize(10);
          doc.text('VENCIMENTO', 10, linha );
          doc.text('LIQUIDAÇÃO', 40, linha );
          doc.text('COMANDA', 70, linha );
          doc.text('VENDEDOR', 90, linha );
          doc.text('CLIENTE', 150, linha );
          doc.text('TIPO PGTO.', 210, linha );
          doc.text('VALOR', 267, linha );
          doc.setFont("helvetica", 'normal');
        },

       
        gerarPdfRelatorio() {
            const doc = new jsPDF("l", "mm", "a4");

            //doc.setFont("helvetica", "bold");
            doc.setFont("helvetica");

            doc.setFontSize(10);

            //let currentY = 10;
            let currentPage = 1;
            let linha = 30;

            this.gerarCabecalho(doc, linha)
            linha += 5

            this.comandas.forEach((comanda) => {
                //const comandaText = `ID: ${comanda.id}, Total: ${comanda.total}, Data: ${comanda.data_comanda}`;
                //doc.text(20, linha, comandaText);
                doc.text(comanda.id.toString(), 10, linha);
                doc.text(moment(comanda.data_comanda).format("DD/MM/YYYY"), 30, linha);
                doc.text(comanda.cliente.nome.substring(0, 20), 50, linha);
                doc.text(this.formataGuarani(comanda.total), 180, linha, "right");
                doc.text(this.formataGuarani(comanda.total_faturado), 220, linha, "right");
                this.vendedor ? '' : doc.text(comanda.vendedor.nome.substring(0, 20), 230, linha, "left");

                linha += 5;

                if (linha + 10 > 200) {
                    doc.text(10, linha + 10, `Relátorio no período de:  ${moment(this.editedItem.dataInicial).format("DD/MM/YYYY")} até: ${moment(this.editedItem.dataFinal).format("DD/MM/YYYY")}`);
                    doc.text(120, linha + 10, this.empresa.nome);
                    doc.text(270, linha + 10, `Página ${currentPage}`);
                    doc.addPage();
                    linha = 30;
                    currentPage++;

                     this.gerarCabecalho(doc, linha)
                     linha += 5
                }
            });

            linha += 30;
            let totalGeral = 0;
            let totalGeralFaturado = 0;

            if(linha > 190){
              linha = 30
              doc.addPage()
            }
            this.gerarCabecalhoVendas(doc, linha)
            linha += 5
            this.totalVendedores.sort((a, b) => b.total_vendas - a.total_vendas)
            this.totalVendedores.forEach((venda) => {
                doc.text(venda.nome, 10, linha);
                totalGeral += venda.total_vendas;
                totalGeralFaturado += venda.total_faturado;
                doc.text(this.formataGuarani(venda.total_vendas),180,linha,"right");
                doc.text(this.formataGuarani(venda.total_faturado),220,linha,"right");
                linha += 5;
                if (linha + 10 > 200) {
                    doc.text(270, linha + 10, `Página ${currentPage}`);
                    doc.addPage();
                    linha = 30;
                    currentPage++;
                }
            });
            doc.text(this.formataGuarani(totalGeral), 180, linha + 5, "right");
            doc.text(this.formataGuarani(totalGeralFaturado), 220, linha + 5, "right");

            doc.text(270, 200, `Página ${currentPage}`);
            doc.save("relatorio.pdf");
        },

        gerarPdfRelatorioFinanceiro() {
            const doc = new jsPDF("l", "mm", "a4");

            //doc.setFont("helvetica", "bold");
            doc.setFont("helvetica");

            doc.setFontSize(10);

            //let currentY = 10;
            let currentPage = 1;
            let linha = 30;

            this.gerarCabecalhoFinanceiro(doc, linha)
            linha += 5

            this.receitas.forEach((receita) => {
                doc.text(moment(receita.data_vencimento).format("DD/MM/YYYY"), 10, linha);
                doc.text(moment(receita.data_liquidacao).format("DD/MM/YYYY"), 40, linha);
                doc.text(receita.comanda__id.toString(), 70, linha);
                doc.text(receita.comanda__vendedor__nome.substring(0, 30), 90, linha);
                doc.text(receita.cliente__nome.substring(0, 30), 150, linha);
                doc.text(receita.modalidade_pagamento__nome.substring(0, 30), 210, linha);
                doc.text(this.formataGuarani(receita.valor_total), 280, linha, "right");

                linha += 5;

                if (linha + 10 > 200) {
                    doc.text(10, linha + 10, `Relátorio no período de:  ${moment(this.editedItem.dataInicial).format("DD/MM/YYYY")} até: ${moment(this.editedItem.dataFinal).format("DD/MM/YYYY")}`);
                    doc.text(120, linha + 10, this.empresa.nome);
                    doc.text(270, linha + 10, `Página ${currentPage}`);
                    doc.addPage();
                    linha = 30;
                    currentPage++;

                     this.gerarCabecalhoFinanceiro(doc, linha)
                     linha += 5
                }
            });

            linha += 30;
            let totalGeral = 0;
            
            if(linha > 190){
              linha = 30
              doc.addPage()
            }

            let totalGeralPorTipo = 0
            this.totalVendasPorTipoPgto.forEach((vendaTipo) => {
                doc.text(vendaTipo.nome, 10, linha);
                totalGeralPorTipo += vendaTipo.total_vendas;
                doc.text(this.formataGuarani(vendaTipo.total_vendas),180,linha,"right");
                linha += 5;
                if (linha + 10 > 200) {
                    doc.text(270, linha + 10, `Página ${currentPage}`);
                    doc.addPage();
                    linha = 30;
                    currentPage++;
                }
            });
            doc.setFont("helvetica", "bold");
            doc.text('Total por tipo de pagamento', 10, linha+5);
            doc.text(this.formataGuarani(totalGeralPorTipo), 180, linha+5, "right");
            doc.setFont("helvetica", "normal");
            linha += 5;






            if(linha > 170){
              linha = 30
              doc.addPage()
            }
            this.gerarCabecalhoVendasFinanceiro(doc, linha+15)
            linha += 20
            this.totalVendedores.sort((a, b) => b.total_vendas - a.total_vendas)
            this.totalVendedores.forEach((venda) => {
                doc.text(venda.nome, 10, linha);
                totalGeral += venda.total_vendas;
                doc.text(this.formataGuarani(venda.total_vendas),180,linha,"right");
                linha += 5;
                if (linha + 10 > 200) {
                    doc.text(270, linha + 10, `Página ${currentPage}`);
                    doc.addPage();
                    linha = 30;
                    currentPage++;
                }
            });
            doc.setFont("helvetica", "bold");
            doc.text('Total por colaborador', 10, linha + 5,);
            doc.text(this.formataGuarani(totalGeral), 180, linha + 5, "right");
            doc.setFont("helvetica", "normal");

            doc.text(270, 200, `Página ${currentPage}`);
            doc.save("relatorio.pdf");
        },

         gerarPdfRelatorio_() {
            // Tamanho da página A4
            const pageSize = {
                width: 595.28,
                height: 841.89,
            };

            // Margens da página
            const pageMargins = {
                top: 20,
                bottom: 20,
                left: 20,
                right: 20,
            };

            // Tamanho do texto e espaçamento
            //const fontSize = 12;
            const lineHeight = 20;

            // Função para gerar o relatório
            // function generatePDF() {
            const doc = new jsPDF();

            let currentY = pageMargins.top;
            let currentPage = 1;

            this.comandas.forEach((comanda) => {
                // Adicionar comanda ao PDF
                const comandaText = `ID: ${comanda.id}, Total: ${comanda.total}, Data: ${comanda.data_comanda}`;
                doc.text(pageMargins.left, currentY, comandaText);

                // Atualizar a posição Y
                currentY += lineHeight;

                // Verificar se há espaço suficiente na página atual
                if (
                    currentY + lineHeight >
                    pageSize.height - pageMargins.bottom
                ) {
                    // Adicionar número da página
                    doc.text(
                        pageSize.width - pageMargins.right,
                        pageSize.height - pageMargins.bottom + 10,
                        `Página ${currentPage}`
                    );

                    // Adicionar nova página
                    doc.addPage();
                    currentY = pageMargins.top;
                    currentPage++;
                }
            });

            // Adicionar número da última página
            doc.text(
                pageSize.width - pageMargins.right,
                pageSize.height - pageMargins.bottom + 10,
                `Página ${currentPage}`
            );

            // Salvar o arquivo PDF
            doc.save("relatorio.pdf");
            // }
        },

        async produtosMaisVendidos() {
            const servidor = this.api.SERVER_URL
            const token = localStorage.getItem('access');
            const headers = {
                        Authorization: `Bearer ${token}`
            };

            try {

                const response = await axios.get(`${servidor}product/mais_vendidos/`, {
                params: { mes: this.mes, ano: this.ano, empresa: this.empresa.id },
                headers: headers 
                });

                if(response.status == 401){
                this.$router.push('login')
                this.mensagem('Faça login novamente!', "Atenção", 'warning', 2)
                return false
                }

                console.log('Produtos mais vendidos: ', response.data)
                
                const aux = response.data
                aux.map((item)=>{
                //console.log(item.id, item.produto.name, item.total_quantidade);
                //console.log(item.id, item.produto.name, item.total_quantidade);
                console.log(item);
                })
                //console.log(aux);

                this.produtos = response.data

                console.log('****************************************************************');
                console.log(this.produtos);

                this.gerarPdfRelatorioProdutosMaisVendidos()

                

            } catch (error) {

                console.error('Erro:', error);
                if(error.response.status == 401){
                this.$router.push('login')
                this.mensagem('Faça login novamente!', "Atenção", 'warning', 2)
                return false
                }

            }
        },


        gerarCabecalhoProdutosMaisVendidos(doc, linha) {
          doc.setFont("helvetica", 'bold');
          doc.setFontSize(24);
          doc.text('Relatório de produtos mais vendidos', 10, linha-10 );
          //linha += 5
          doc.setFontSize(10);
          doc.text('CÓDIGO', 10, linha );
          doc.text('PRODUTO', 40, linha );
          doc.text('QUANTIDADE VENDIDA', 120, linha );
          doc.setFont("helvetica", 'normal');
        },

        gerarPdfRelatorioProdutosMaisVendidos() {
            console.log('PRODUTOS NO RELATORIO');
            console.log(this.produtos[0].produto_id, this.produtos[0].produto_name);
            const doc = new jsPDF("p", "mm", "a4");

            //doc.setFont("helvetica", "bold");
            doc.setFont("helvetica");

            doc.setFontSize(10);

            //let currentY = 10;
            let currentPage = 1;
            let linha = 30;

            this.gerarCabecalhoProdutosMaisVendidos(doc, linha)
            linha += 5

            this.produtos.forEach((produto) => {
                doc.text(produto.produto_id.toString(), 24, linha, "right");
                doc.text(produto.produto_name.substring(0, 30), 40, linha);
                //doc.text(produto.produto_name, 40, linha);
                doc.text(produto.total_quantidade.toFixed(2), 160, linha, "right");

                linha += 5;

                if (linha + 10 > 270) {
                    //doc.text(10, linha + 10, `Relátorio no período de:  ${moment(this.editedItem.dataInicial).format("DD/MM/YYYY")} até: ${moment(this.editedItem.dataFinal).format("DD/MM/YYYY")}`);
                    doc.text(120, linha + 10, this.empresa.nome);
                    doc.text(10, linha + 10, `Página ${currentPage}`);
                    doc.addPage();
                    linha = 30;
                    currentPage++;

                     this.gerarCabecalhoProdutosMaisVendidos(doc, linha)
                     linha += 5
                }
            });


            doc.text(10, 280, `Página ${currentPage}`);
            doc.save("relatorio produtos.pdf");
        },


        //**************** */
        async servicosMaisVendidos() {
            const servidor = this.api.SERVER_URL
            const token = localStorage.getItem('access');
            const headers = {
                        Authorization: `Bearer ${token}`
            };

            try {

                const response = await axios.get(`${servidor}service/mais_vendidos/`, {
                params: { mes: this.mes, ano: this.ano, empresa: this.empresa.id },
                headers: headers 
                });

                if(response.status == 401){
                this.$router.push('login')
                this.mensagem('Faça login novamente!', "Atenção", 'warning', 2)
                return false
                }

                console.log('Serviços mais vendidos: ', response.data)
                
                const aux = response.data
                aux.map((item)=>{
                //console.log(item.id, item.produto.name, item.total_quantidade);
                //console.log(item.id, item.produto.name, item.total_quantidade);
                console.log(item);
                })
                //console.log(aux);

                this.servicos = response.data

                console.log('****************************************************************');
                console.log(this.servicos);

                this.gerarPdfRelatorioServicosMaisVendidos()

                

            } catch (error) {

                console.error('Erro:', error);
                if(error.response.status == 401){
                this.$router.push('login')
                this.mensagem('Faça login novamente!', "Atenção", 'warning', 2)
                return false
                }

            }
        },


        gerarCabecalhoServicosMaisVendidos(doc, linha) {
          doc.setFont("helvetica", 'bold');
          doc.setFontSize(24);
          doc.text('Relatório de serviços mais vendidos', 10, linha-10 );
          //linha += 5
          doc.setFontSize(10);
          doc.text('CÓDIGO', 10, linha );
          doc.text('SERVIÇO', 40, linha );
          doc.text('QUANTIDADE VENDIDA', 120, linha );
          doc.setFont("helvetica", 'normal');
        },

        gerarPdfRelatorioServicosMaisVendidos() {
            console.log('PRODUTOS NO RELATORIO');
            console.log(this.servicos[0].produto_id, this.servicos[0].produto_name);
            const doc = new jsPDF("p", "mm", "a4");

            //doc.setFont("helvetica", "bold");
            doc.setFont("helvetica");

            doc.setFontSize(10);

            //let currentY = 10;
            let currentPage = 1;
            let linha = 30;

            this.gerarCabecalhoServicosMaisVendidos(doc, linha)
            linha += 5

            this.servicos.forEach((servico) => {
                doc.text(servico.servico_id.toString(), 24, linha, "right");
                doc.text(servico.servico_name.substring(0, 30), 40, linha);
                //doc.text(servico.servico_name, 40, linha);
                doc.text(servico.total_quantidade.toFixed(2), 160, linha, "right");

                linha += 5;

                if (linha + 10 > 270) {
                    //doc.text(10, linha + 10, `Relátorio no período de:  ${moment(this.editedItem.dataInicial).format("DD/MM/YYYY")} até: ${moment(this.editedItem.dataFinal).format("DD/MM/YYYY")}`);
                    doc.text(120, linha + 10, this.empresa.nome);
                    doc.text(10, linha + 10, `Página ${currentPage}`);
                    doc.addPage();
                    linha = 30;
                    currentPage++;

                     this.gerarCabecalhoServicosMaisVendidos(doc, linha)
                     linha += 5
                }
            });


            doc.text(10, 280, `Página ${currentPage}`);
            doc.save("relatorio serviços.pdf");
        },


    },

    computed: {
        formTitle() {
            return (
                (this.editedIndex === -1 ? "Novo " : "Editar ") + this.recurso
            );
        },
        /* Usar computed para quando usar tradução personalizar */
        /* SemDadosComputed(){
      let texto = `No data available`
      if(this.editedItem.selectedPais){
          if(this.editedItem.selectedPais.sigla === 'PY')
            texto = `Datos indisponíbles`
          else if(this.editedItem.selectedPais.sigla === 'BR')
            texto = `Dados indisponíveis`
      }
      return texto
    }, */
        /*     hintCelularComputed(){
        if(this.editedItem.celular !== null && this.editedItem.celular.valid !==undefined && this.editedItem.celular.valid !==null)
            return (this.editedItem.celular.valid ? `Celular válido ${this.editedItem.celular.number}` : `Inválido ${this.editedItem.celular.valid}`)
        return ''
    },
 */
        /* MASCARAS */

        /* ICONES */
        /* iconNameComputed() {

        if(this.editedItem.genero !== null){
            if(this.editedItem.genero === 'masculino') 
                return 'mdi-face-man'
            if(this.editedItem.genero === 'feminino') 
                return 'mdi-face-woman'
        }

        return 'mdi-account'
    }, */
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
    },
};
</script>


<style>
.dialog-above-menu {
    /* para o modal não ficar atraz do menu do template */
    z-index: 1000; /* Defina um valor alto para o z-index */
    background-color: gray;
}
.custom-tel-input .v-select__selections {
    margin-left: 5px;
    justify-content: center;
}
.custom-tel-input .v-input__slot {
    /* quando aplica dense no vue-tel-input-vuetify
  o select da bandeira fica menor, essa linha iguala a
  altura com o input do telefone
   */
    height: 53px !important;
}

/* Personalize o scroll do v-dialog */
.custom-scroll {
    /* max-height: 400px; */ /* Defina a altura máxima do conteúdo do dialog */
    /* overflow-y: auto; */ /* Habilita o scroll vertical quando o conteúdo excede a altura máxima */
    scrollbar-width: thin; /* Tamanho da barra de scroll (opcional) */
}

/* Personalize o estilo da barra de scroll (opcional) */
.custom-scroll::-webkit-scrollbar {
    width: 8px;
}

.custom-scroll::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-color);
}
</style>


<style scoped>
/* COR BOTOES */
.custom-color-button {
  color: white !important;
  background-color: #009688 !important;
}
.custom-color-button-cancelar {
  color: white !important;
  background-color: #B71C1C !important;
}
.active-button {
  /* obs: para funcionar o backgound-color não pode definir color direto no v-btn */
  background-color: #d2cf19 !important; /* Defina a cor de fundo do botão ativo */
  color: white !important; /* Defina a cor do texto do botão ativo */
}
.inactive-button {
  /* obs: para funcionar o backgound-color não pode definir color direto no v-btn */
  background-color: white !important;
  color: black !important; /* Defina a cor do texto do botão ativo */
}
.custom-border-bottom {
  border-radius: 0px !important;
}
</style>

